var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$style.genericIcon, _vm.colorStyle],style:({ backgroundColor: _vm.modelColor })},[_c('p',{class:_vm.$style.genericIconLetter},[_vm._v(" "+_vm._s(_vm.modelDisplayLabel.charAt(0).toUpperCase())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }